import { slugify } from "../../shared-utils/slugify"

// Create an array of subheadings for the article navigation
const getSanitySubHeadings = doc => {
  return doc._rawContent
    .filter(block => block._type === "block" && block.style === "h2")
    .map(block => block.children[0].text)
    .map(heading => ({
      id: `#${slugify(heading)}`,
      text: heading,
    }))
}

export default getSanitySubHeadings
